import { Reveal } from "@/components/Reveal";
import { AnimatedCounter } from "@/components/AnimatedCounter";
import { SectionLabel } from "@/components/home/SectionLabel";
import { RESULTS, IMAGES } from "@/data/content";

export function ResultsSection() {
    return (
        <section className="relative bg-sagedark text-cream overflow-hidden z-10">
            <img
                src={IMAGES.analytics}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 w-full h-full object-cover opacity-[0.12] grayscale"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-sagedark via-sagedark/95 to-sage/80" />
            <div className="relative max-w-[1240px] mx-auto px-6 lg:px-10 py-24">
                <Reveal>
                    <SectionLabel className="text-terracotta">Results</SectionLabel>
                    <h2 className="font-heading text-4xl sm:text-5xl tracking-tight mt-4 max-w-2xl">
                        Numbers our practices actually see.
                    </h2>
                </Reveal>
                <div className="mt-14 grid md:grid-cols-3 gap-px border-t border-l border-cream/15">
                    {RESULTS.map((r, i) => (
                        <Reveal key={r.line} delay={i * 0.12}>
                            <div className="border-r border-b border-cream/15 p-9 h-full">
                                <div className="font-heading text-5xl lg:text-6xl text-cream">
                                    <AnimatedCounter value={r.stat} />
                                </div>
                                <div className="text-cream/90 font-medium mt-5 text-lg">{r.line}</div>
                                <div className="font-mono text-[11px] uppercase tracking-[0.14em] text-terracotta mt-2">
                                    {r.meta}
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
